(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function wrapAmount(value) {
    return '<span class="free-shipping-progress__amount">' + value + '</span>';
  }

  var AMOUNT_TOKEN = /\[amount\]/;

  function updateAll(cart) {
    var bars = document.querySelectorAll('[data-free-shipping-progress]');
    if (!bars.length || !cart) return;

    bars.forEach(function (bar) {
      if (bar.dataset.forceDefault === 'true') return;

      var threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold) return;

      var defaultText = bar.dataset.defaultText || 'Free shipping on orders [amount]+';
      var remainingText = bar.dataset.remainingText || "You're [amount] away from free shipping!";
      var completeText = bar.dataset.completeText || "You've unlocked free shipping!";

      var total = cart.total_price;
      var remaining = Math.max(threshold - total, 0);
      var percent = Math.min((total / threshold) * 100, 100);
      var complete = cart.item_count > 0 && remaining === 0;

      var fill = bar.querySelector('[data-free-shipping-fill]');
      var pointer = bar.querySelector('[data-free-shipping-pointer]');
      var copy = bar.querySelector('[data-free-shipping-copy]');

      if (fill) {
        fill.setAttribute('width', percent);
        fill.setAttribute('fill', complete ? '#4ade80' : '#F1873B');
      }
      if (pointer) {
        pointer.style.left = percent + '%';
      }

      bar.classList.toggle('is-complete', complete);

      if (cart.item_count === 0) {
        if (copy) copy.innerHTML = defaultText.replace(AMOUNT_TOKEN, wrapAmount(formatMoney(threshold)));
      } else if (remaining > 0) {
        if (copy) copy.innerHTML = remainingText.replace(AMOUNT_TOKEN, wrapAmount(formatMoney(remaining)));
      } else {
        if (copy) copy.innerHTML = completeText;
      }
    });
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(updateAll)
      .catch(function (err) { console.error('Free shipping progress refresh failed:', err); });
  }

  window.refreshFreeShippingProgress = refresh;

  ['DOMContentLoaded', 'cart:updated', 'cart:refresh', 'cart:build', 'theme:cart:change'].forEach(function (evt) {
    document.addEventListener(evt, refresh);
  });
})();